"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throwErrorFromResponse = exports.ErrorMapping = void 0;
const errors_1 = require("./errors");
const ParentIdIsRequiredError_1 = require("./errors/ParentIdIsRequiredError");
exports.ErrorMapping = {
    NumberOfTagChildrenCannotBeAlteredError: errors_1.NumberOfTagChildrenCannotBeAlteredError,
    TagExistsError: errors_1.TagExistsError,
    TagHasChildrenError: errors_1.TagHasChildrenError,
    TagParentDoesNotExistError: errors_1.TagParentDoesNotExistError,
    ParentIdIsRequiredError: ParentIdIsRequiredError_1.ParentIdIsRequiredError,
    CategorySubjectGroupNotAllowedError: errors_1.CategorySubjectGroupNotAllowedError,
    TagSubjectGroupNotAllowedError: errors_1.TagSubjectGroupNotAllowedError
};
function throwErrorFromResponse(response) {
    var _a;
    const errorName = (_a = response.json) === null || _a === void 0 ? void 0 : _a.reason;
    if (errorName && exports.ErrorMapping[errorName]) {
        throw new exports.ErrorMapping[errorName]();
    }
    throw new Error('Unexpected server response');
}
exports.throwErrorFromResponse = throwErrorFromResponse;
//# sourceMappingURL=ErrorMapping.js.map